import { render } from "./ValidatableTextInput.vue?vue&type=template&id=0bb70c7f"
import script from "./ValidatableTextInput.vue?vue&type=script&lang=js"
export * from "./ValidatableTextInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__